import { __rest } from "tslib";
import * as React from 'react';
import classNames from 'classnames';
import { ConfigConsumer } from '../config-provider';
const Grid = (_a) => {
    var { prefixCls, className, hoverable = true } = _a, props = __rest(_a, ["prefixCls", "className", "hoverable"]);
    return (React.createElement(ConfigConsumer, null, ({ getPrefixCls }) => {
        const prefix = getPrefixCls('card', prefixCls);
        const classString = classNames(`${prefix}-grid`, className, {
            [`${prefix}-grid-hoverable`]: hoverable,
        });
        return React.createElement("div", Object.assign({}, props, { className: classString }));
    }));
};
export default Grid;
